import React from 'react';
import Layout from '../layouts/user';

/**
 * Shared loading / not-found screens for the product-engine route components.
 */
export const SchemaLoadingScreen = () => (
  <Layout menu="plans">
    <div className="nk-content-body">
      <div className="nk-block-head text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </Layout>
);

export const ProductNotFoundScreen = ({ productType }) => (
  <Layout menu="plans">
    <div className="nk-content-body">
      <div className="nk-block-head text-center">
        <h2 className="nk-block-title fw-normal">Product Not Found</h2>
        <p>No product schema found for "{productType}".</p>
      </div>
    </div>
  </Layout>
);
